import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=638290f5"
import script from "./EventList.ts?vue&type=script&lang=ts&external"
export * from "./EventList.ts?vue&type=script&lang=ts&external"
import style0 from "./EventList.vue?vue&type=style&index=0&id=638290f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports